import { createFileRoute } from '@tanstack/react-router'

interface ShopInfo {
  shop_no: number
  shop_name: string
}

export const Route = createFileRoute('/shop-limit-exceeded')({
  component: ShopLimitExceededPage,
  validateSearch: (search) => ({
    mall_id: search.mall_id as string,
    requested_shop_no: search.requested_shop_no as string,
    max_shops: search.max_shops as string,
    shops: search.shops as string,
  }),
})

function ShopLimitExceededPage() {
  const { mall_id, requested_shop_no, max_shops, shops } = Route.useSearch()

  // shops 파라미터 디코딩
  let registeredShops: ShopInfo[] = []
  try {
    const decoded = atob(shops)
    registeredShops = JSON.parse(decoded)
  } catch {
    registeredShops = []
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      <div className="max-w-lg w-full bg-surface-lowest rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <div className="text-5xl mb-4">🚫</div>
          <h1 className="text-xl font-bold text-on-surface mb-2">
            샵 등록 한도 초과
          </h1>
          <div className="w-16 h-1 bg-red-500 mx-auto"></div>
        </div>

        <div className="mb-6">
          <p className="text-on-surface mb-4">
            현재 최대 <strong>{max_shops}개</strong> 샵까지 등록할 수 있습니다.
          </p>
          <p className="text-on-surface-variant">
            등록된 샵의 Cafe24 관리자 페이지에서 접속해주세요.
          </p>
        </div>

        {/* 등록된 샵 목록 */}
        <div className="bg-surface rounded-lg p-4 mb-6 text-left">
          <h3 className="text-base font-semibold text-on-surface mb-3">
            등록된 샵 목록
          </h3>
          <ul className="space-y-2">
            {registeredShops.map((shop) => (
              <li
                key={shop.shop_no}
                className="flex items-center text-on-surface"
              >
                <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                <span>
                  {shop.shop_name}{' '}
                  <span className="text-on-surface-variant">(#{shop.shop_no})</span>
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* 현재 접속 시도 정보 */}
        <div className="bg-red-50 rounded-lg p-4 mb-6 text-left">
          <p className="text-sm text-red-800">
            <span className="font-medium">접속 시도한 샵:</span> 샵 #
            {requested_shop_no}
          </p>
        </div>

        {/* 안내 문구 */}
        <div className="border-t pt-6">
          <p className="text-sm text-on-surface-variant">
            다른 샵으로 변경을 원하시면 자사몰 사관학교로 문의해주세요.
          </p>
          <p className="text-xs text-outline-variant mt-2">쇼핑몰 ID: {mall_id}</p>
        </div>
      </div>
    </div>
  )
}
